export default "__VITE_ASSET__C6YZz3bc__"